<template>
  <div class="vabContent">
    <a-layout-content class="vab-content">
      <router-view v-slot="{ Component }">
        <transition mode="out-in" name="fade-transform">
          <div> 
            <component :is="Component" />
          </div>
        </transition>
      </router-view>
    </a-layout-content>
  </div>
</template>

<script>
export default {}
</script>

<style lang='less' scoped>
.fade-transform-leave-active,
.fade-transform-enter-active {
  transition: all 0.2s;
}
.ant-layout-content {
  height: calc(100vh - 50px)!important;
  overflow: hidden;
}
.vab-content {
  padding:5px;
  background: #fff;
  min-height: 280px;
}
</style>